import request from "../utils/request";

export function GET_PhaseList(token, projectId) {
  return request.get(`/Phase/List/${projectId}`, null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function POST_Phase(token, projectId, formData) {
  return request.post(`/Phase/${projectId}`, formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function PUT_Phase(token, phaseId, formData) {
  return request.put(`/Phase/${phaseId}`, formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function DELETE_Phase(token, phaseId) {
  return request.delete(`/Phase/${phaseId}`, null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
